export const handleOnlyDigits = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const nativeEvent = e.nativeEvent as KeyboardEvent;

    // Разрешаем клавиши Backspace, Tab, Delete, стрелки и сочетания с Ctrl
    if (
        e.key === 'Backspace' ||
        e.key === 'Tab' ||
        e.key === 'Delete' ||
        e.key === 'ArrowLeft' ||
        e.key === 'ArrowRight' ||
        (e.ctrlKey && (nativeEvent.code === 'KeyA' || nativeEvent.code === 'KeyC'))
    ) {
        return;
    }

    // Если нажата клавиша Ctrl + V
    if (e.ctrlKey && nativeEvent.code === 'KeyV') {
        setTimeout(() => {
            const input = e.target as HTMLInputElement;
            if (input) { // Проверяем, что input не null
                const value = input.value;

                // Фильтруем значение, чтобы оставить только цифры и точки
                const filteredValue = value.replace(/[^0-9]/g, '');
                input.value = filteredValue; // Устанавливаем отфильтрованное значение

                // Преобразуем отфильтрованное значение
                const endDate = filteredValue ? filteredValue : '';
            }
        }, 0);
        return;
    }
    // Разрешаем только цифры
    if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
    }
};

export const handleOnlyLettersAndSpecialChars = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Разрешаем только буквы, тире и пробелы
    if (!/[a-zA-Zа-яА-ЯёЁ\- ]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
        e.preventDefault();
    }
};

/**
 * Фильтрует строку, оставляя только кириллицу, дефис и пробелы.
 * Валидация имени/фамилии/отчества:
 * - Разрешены: только кириллица (а-я, ё), одиночные пробелы, одиночные дефисы
 * - Запрещены: цифры, латиница, спецсимволы
 * - Запрещены: два дефиса подряд (--), два пробела подряд (  )
 * - Запрещено: начинать строку с пробела или дефиса
 * - Обязательно: хотя бы 2 кириллические буквы
 * @param value — строка ввода
 * @returns объект с отфильтрованной строкой и флагом валидности
 */
export interface NameValidationResult {
    filteredValue: string;
    isValid: boolean;
}
export function validateName(value: string, required: boolean = true): NameValidationResult {
    if (value === undefined || value === null) {
        return { filteredValue: '', isValid: !required };
    }

    // Убираем всё, кроме кириллицы, пробела и дефиса
    let filtered = value.replace(/[^а-яА-ЯЁё\-\s]/g, '');

    // Удаляем двойные дефисы
    while (filtered.includes('--')) {
        filtered = filtered.replace('--', '-');
    }

    // Удаляем двойные пробелы
    while (filtered.includes('  ')) {
        filtered = filtered.replace('  ', ' ');
    }

    // Запрет на начало с пробела/дефиса
    filtered = filtered.replace(/^[\s\-]+/, '');

    const letters = filtered.match(/[а-яА-ЯЁё]/gi) || [];
    const letterCount = letters.length;
    const isValid = filtered.trim() === '' ? !required : letterCount >= 2;

    return {
        filteredValue: filtered,
        isValid,
    };
}

export interface EmailValidationResult {
    filteredValue: string;
    isValid: boolean;
}

export function validateEmail(value: string, required: boolean = false): EmailValidationResult {
    if (value === undefined || value === null) {
        return { filteredValue: '', isValid: !required };
    }
    let filtered = value.replace(/[^a-zA-Z0-9._%+\-@]/g, '');
    const isValid = filtered === '' ? !required : /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(filtered);
    return {
        filteredValue: filtered,
        isValid,
    };
}

export const handleOnlyEmailChars = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
        e.key.length === 1 &&
        !/[a-zA-Z0-9._%+\-@]/.test(e.key) &&
        !e.ctrlKey &&
        !e.metaKey
    ) {
        e.preventDefault();
    }
};